module.exports = __webpack_public_path__ + "static/media/Checkbox-Minus.8fee0b81.svg";